<template>
  <div class="youtube-short-challenge">
    <el-form-item :label="`${title} Challenge`">
      <el-button class="youtube-short-challenge__btn" type="default" @click="showContent = !showContent"
                 :icon="showContent === true ? 'el-icon-top' : 'el-icon-bottom'"
                 circle></el-button>
      <div v-if="showContent" class="youtube-short-challenge__content position" :style="{borderLeftColor: borderColor}">
<!--          <el-switch style="margin: 10px auto;" v-model="brand[type].show_submissions" active-text="With Submissions"
                     inactive-text="Without Submissions" active-color="#13ce66" inactive-color="#df2758"></el-switch>-->
        <el-switch class="youtube-short-challenge__switch-btn"
                   v-model="brand[type].show_budget"
                   active-text="Views Budget"
                   inactive-text="Rewards budget"
                   active-color="#13ce66"
                   inactive-color="#df2758"
        ></el-switch>
        <el-switch class="youtube-short-challenge__switch-btn" v-model="brand[type].trending"
                   active-text="In Trending" inactive-text="Out of Trending"
                   active-color="#13ce66" inactive-color="#df2758"></el-switch>

        <el-switch v-if="!brand[type].show_budget" class="youtube-short-challenge__switch-btn" v-model="brand[type].manual_payment"
                   active-text="With Manual Payment" inactive-text="Without Manual Payment"
                   active-color="#13ce66" inactive-color="#df2758"></el-switch>

        <el-switch  v-model="brand[type].multiple_submissions" active-text="Multiple submissions" inactive-text=""
                    active-color="#13ce66" inactive-color="#df2758" class="youtube-short-challenge__switch-btn"></el-switch>
<!--        <el-form-item :label="`${title} Earn Up To Text`" prop="campaign_main_title">
          <el-input v-model="brand[type].earn_up"></el-input>
        </el-form-item>
        <el-form-item :label="`${title} Free To Use Text`" prop="campaign_main_title">
          <el-input v-model="brand[type].free_to_use"></el-input>
        </el-form-item>-->
        <div v-if="type === 'short_challenge' || type === 'tiktok_challenge' || type === 'instagram_challenge' || type === 'youtube_regular'">
          <el-form-item label="Budget ($)">
            <el-input v-model="budget"></el-input>
          </el-form-item>
          <el-form-item v-if="!brand[type].show_budget" label="Reward Title">
            <el-input v-model="brand[type].reward_title"></el-input>
          </el-form-item>
          <el-form-item v-if="!brand[type].show_budget" label="Reward Text" prop="challenge_top_tips" class="youtube-short-challenge__editor">
            <vue-editor v-model="brand[type].reward_text" class="position"/>
          </el-form-item>
          <el-form-item label="Pricing thresholds" v-if="brand[type].show_budget">
            <el-button class="youtube-short-challenge__btn" type="default" @click="showPricing = !showPricing"
                       :icon="showPricing === true ? 'el-icon-top' : 'el-icon-bottom'"
                       circle></el-button>
            <el-table v-if="showPricing" :data="pricingThresholds">
              <el-table-column prop="threshold" label="Thresholds (views)" :formatter="commaNumTable"></el-table-column>
              <el-table-column label="Value ($)" align="center">
                <template slot-scope="props">
                  <input class="el-input__inner" type="text" :value="displayPricingValue(props.row.id)"
                         @input="savePricing(props.row.id, $event)">
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="Additional perks">
            <el-button class="youtube-short-challenge__btn" type="default" @click="showPerks = !showPerks"
                       :icon="showPerks === true ? 'el-icon-top' : 'el-icon-bottom'"
                       circle></el-button>
            <div v-if="showPerks" class="perks">
              <el-form-item label="Early Bird Description" class="position">
                <el-input v-model="brand[type].guaranteed_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Early Bird Payment" class="position">
                <el-input v-model="gp"></el-input>
              </el-form-item>
              <el-form-item label="Bonus Title" class="position">
                <el-input v-model="brand[type].bonus_title"></el-input>
              </el-form-item>
              <el-form-item label="Bonus Description" class="position">
                <el-input v-model="brand[type].bonus_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Shoutout Description" class="position">
                <el-input v-model="brand[type].shoutout_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Shoutout amount" class="position">
                <el-input v-model="shoutout"></el-input>
              </el-form-item>
              <el-form-item label="Affiliate Description" class="position">
                <el-input v-model="brand[type].affiliate_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount Description" class="position">
                <el-input v-model="brand[type].discount_desc" class="position"/>
              </el-form-item>
              <el-form-item label="Discount percentage" class="position">
                <el-input v-model="brand[type].discount_value"></el-input>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="Campaign availability">
            <el-button class="youtube-short-challenge__btn" type="default" @click="showCampaignAvailability = !showCampaignAvailability"
                       :icon="showCampaignAvailability === true ? 'el-icon-top' : 'el-icon-bottom'"
                       circle></el-button>
            <div v-if="showCampaignAvailability">
              <el-form-item label="" class="position">
              <el-switch class="modal__affiliate" v-model="brand[type].allow_rejected_user" active-text="Rejected users" inactive-text=""
                         active-color="#13ce66" inactive-color="#df2758"></el-switch>
              </el-form-item>
              <el-form-item label="" class="position">
              <el-switch class="modal__affiliate" v-model="brand[type].allow_pending_user" active-text="Pending users" inactive-text=""
                         active-color="#13ce66" inactive-color="#df2758"></el-switch>
              </el-form-item>
            </div>
          </el-form-item>
          <div class="youtube-short-challenge__video">
            <div class="youtube-short-challenge__title">Content example</div>
            <div v-if="!video && !previewVideo" class="youtube-short-challenge__video--uploader">
              <label for="contentUpload">
                <i class="el-icon-video-camera-solid fa-lg mr5"></i> Upload Image or Video
              </label>
              <input v-show="false" type="file" id="contentUpload" @change="uploadVideo">
            </div>
            <div v-else class="uploaded-video">
              <img v-if="!isImage(fileName)" class="uploaded-video__image" src="@/assets/images/video.svg" alt="challenge">
              <img v-else class="uploaded-video__image" :src="getImage" alt="challenge">
              <a class="uploaded-video__name"
              >{{ fileName.length > 40 ? fileName.slice(0, 40) + '...' : fileName }}
              </a>
              <div class="uploaded-video__delete"></div>
              <i class="uploaded-video__delete--icon el-icon-close" @click="removeVideo"></i>
            </div>
          </div>
          <el-form-item label="Description text" class="position" v-if="brand[type].show_budget">
            <vue-editor v-model="brand[type].description" class="position"/>
          </el-form-item>
          <el-form-item label="Link to sound">
            <el-input v-model="brand[type].link"></el-input>
          </el-form-item>
          <!--modal assets-->
          <el-form-item class="youtube-short-challenge__assets" label="Assets">
            <el-button class="youtube-short-challenge__assets--btn" type="default" @click="showAssets = !showAssets"
                       :icon="showAssets === true ? 'el-icon-top' : 'el-icon-bottom'"
                       circle></el-button>
            <div v-if="showAssets" class="youtube-short-challenge__assets--content">
              <div class="asset-uploader">
                <label for="assetUpload"><i class="el-icon-plus fa-lg"></i></label>
                <input v-show="false" type="file" id="assetUpload" @change="uploadAsset">
              </div>
              <div class="list-item">
                <ul>
                  <li v-for="asset in assets.concat(previewAssets)" :key="asset.id">
                    <img class="list-item__image" :src="asset.type === 2 ? videoImage() : asset.path" alt="asset">
                    <a class="list-item__name"
                    >{{ asset.path.length > 40 ? asset.path.split('/').reverse()[0].slice(0, 40) + '...' : asset.path.split('/').reverse()[0] }}
                    </a>
                    <div class="list-item__delete"></div>
                    <i class="list-item__delete--icon el-icon-close" @click="removeAsset(asset.id)"></i>
                  </li>
                </ul>
              </div>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="Steps" prop="challenge_steps" class="youtube-short-challenge__editor">
          <vue-editor v-model="brand[type].steps" class="position"/>
        </el-form-item>
<!--        <el-form-item :label="`${title} Steps Title`" prop="campaign_main_title">
          <el-input v-model="brand[type].campaign_main_title"></el-input>
        </el-form-item>-->
        <el-form-item label="Top Tips" prop="challenge_top_tips" class="youtube-short-challenge__editor">
          <vue-editor v-model="brand[type].top_tips" class="position"/>
        </el-form-item>
        <el-form-item label="Challenge Date" class="mt20">
          <el-date-picker v-model="challengeDate" type="daterange" format="d MMMM yyyy"
                          value-format="yyyy-MM-dd"  start-placeholder="Start date"
                          end-placeholder="End date" range-separator="-"
          ></el-date-picker>
        </el-form-item>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import {VueEditor} from "vue2-editor";
import { mapMutations, mapState } from "vuex";

export default {
  name: "YouTubeShortChallenge",

  data() {
    return {
      inputVisibleHash: false,
      inputValueHash: '',
      previewVideo: null,
      showContent: false,
      showPricing: false,
      showPerks: false,
      showAssets: false,
      showCampaignAvailability:false,
      selectedAssets: [],
      previewAssets: []
    }
  },

  components: { VueEditor },

  props: {
    type: { type: String, required: true }
  },

  computed: {
    ...mapState('brand', ['brand', 'pricingThresholds']),

    gp: {
      get() { return this.brand[this.type].guaranteed_payment / 10 || 0},
      set(value) {
        let challenge = { ...this.brand[this.type]  }
        challenge.guaranteed_payment  = value * 10

        this.brand[this.type] = challenge
      }
    },

    shoutout: {
      get() { return this.brand[this.type].shoutout_payment / 10 || 0},
      set(value) {
          let challenge = { ...this.brand[this.type]  }
          challenge.shoutout_payment  = value * 10

          this.brand[this.type] = challenge
      }
    },

    budget: {
      get() { return this.brand[this.type].budget / 10 || 0 },
      set(value) {
        let challenge = { ...this.brand[this.type]  }
        challenge.budget  = value * 10

        this.brand[this.type] = challenge
      }
    },

    challengeDate: {
      get() {
        if (['youtube_regular', 'short_challenge', 'tiktok_challenge', 'instagram_challenge'].includes(this.type)) {
          if (this.brand[this.type].date_start && this.brand[this.type].date_end) {

            return [this.brand[this.type].date_start, this.brand[this.type].date_end]
          }
        }
        return null
      },
      set(value) {
        if (['youtube_regular','short_challenge', 'tiktok_challenge', 'instagram_challenge'].includes(this.type)) {
          if (Array.isArray(value) && value.length === 2) {
            this.setChallengeDate({ date: value, type: this.type })

          } else this.setChallengeDate({ date: [null, null], type: this.type })
        }
      }
    },
    video() {
      if (this.type === 'youtube_regular') return !!this.brand[this.type].youtube_video
      return !!this.brand[this.type].video
    },

    getImage() {
      console.log(this.previewVideo)
      if (this.previewVideo) return this.previewVideo
      if (this.type === 'youtube_regular') return this.brand[this.type].youtube_video

      return this.brand[this.type].video
    },

    fileName() {
      const video = this.type === 'youtube_regular'
          ? this.brand[this.type].youtube_video
          : this.brand[this.type].video

      if (video) {
        if (video instanceof File) return video.name
        else if(typeof video === "string") return video.split('/').reverse()[0]
      }
      if (this.previewVideo) return this.previewVideo

      return ''
    },

    borderColor() {
      if (this.type === 'youtube_regular') return '#F56C6C'
      else if (this.type === 'instagram_challenge') return '#f5da42'
      else if (this.type === 'short_challenge') return '#E6A23C'
      else if (this.type === 'tiktok_challenge') return '#303133'
      return ''
    },

    title() {
      return {
        youtube_regular: 'YouTube', short_challenge: 'YouTube Short',
        tiktok_challenge: 'TikTok', instagram_challenge: 'Instagram'
      }[this.type]
    },
    assets() {
      if (!this.brand[this.type].assets) return []
      return this.brand[this.type].assets.filter(a => !(a.path instanceof File))
    },
  },

  methods: {
    ...mapMutations('brand', ['setChallengeDate']),

    isImage(string) {
      let extension;
      if (string && typeof string === 'string') extension = string.split('.').reverse()[0]

      return !['mp4', 'mpeg'].includes(extension);
    },

    uploadVideo(event) {
      const file = event.target.files[0]
      this.$emit('challengeVideo', { file: file, type: this.type})

      this.previewVideo = file.type.split('/')[0] === 'image'
          ? URL.createObjectURL(file)
          : file.name
    },

    removeVideo() {
      if (this.type === 'youtube_regular') this.brand[this.type].youtube_video = null
      else this.brand[this.type].video = null

      this.$emit('challengeVideo', { file: null, type: this.type })
      this.previewVideo = null
    },

    displayPricingValue(priceId) {
      const price = this.brand[this.type].pricing
          ? this.brand[this.type].pricing.find(p => p.pricing_id === priceId)
          : null

      return price ? price.payment : null
    },

    savePricing(priceId, event) {
      const pricingIndex = this.brand[this.type].pricing
          ? this.brand[this.type].pricing.findIndex(p => p.pricing_id === priceId)
          : null

      if (pricingIndex !== -1 && pricingIndex !== null) {
        this.brand[this.type].pricing[pricingIndex].payment = event.target.value

      } else {
        if (Array.isArray(this.brand[this.type].pricing)) {

          this.brand[this.type].pricing.push({pricing_id: priceId, payment: event.target.value})
        } else {
          this.brand[this.type].pricing = [{pricing_id: priceId, payment: event.target.value}]
        }
      }
    },
    uploadAsset(event) {
      const file = event.target.files[0]
      const assetId = new Date().getTime()
      if (!this.brand[this.type].assets) {
        this.brand[this.type].assets = []; // Initialize as an empty array
      }
      this.brand[this.type].assets.push({ id: assetId, path: file })
      this.previewAssets.push({
        id: assetId,
        path: file.type.split('/')[0] === 'image' ? URL.createObjectURL(file) : file.name,
        type: file.type.split('/')[0] === 'video' ? 2 : 1
      })
    },

    removeAsset(assetId) {
      this.brand[this.type].assets = this.brand[this.type].assets.filter(a => a.id !== assetId)
      this.previewAssets = this.previewAssets.filter(a => a.id !== assetId)
    },
    videoImage() {
      return require('@/assets/images/video.svg')
    },
    toggleContent() {

    },
  }
}
</script>

<style scoped lang="scss">
.youtube-short-challenge {

  &__switch-btn {
    text-align: left;
    margin-top: 20px;
  }

  &__btn {
    height: 25px;
    width: 25px;
    padding: 0;
    margin-top: 10px;
  }

  &__video {

    &--uploader {
      label {
        border: 1px dashed #d9d9d9;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
          border-color: #e55279;

          i {
            color: #e55279;
          }
        }
      }
    }

    .uploaded-video {
      position: relative;
      overflow: hidden;
      background-color: #fff;
      border: 1px solid #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      margin-top: 10px;
      padding: 10px 10px 10px 90px;
      height: 72px;

      &__image {
        width: 50px;
        height: 50px;
        float: left;
        position: relative;
        z-index: 1;
        margin-left: -80px;
        background-color: #fff;
        border-radius: 6px;
      }

      &__name {
        line-height: 50px;
      }

      &__delete {
        position: absolute;
        right: -17px;
        top: -7px;
        width: 46px;
        height: 26px;
        background: #c0ccda;
        text-align: center;
        transform: rotate(45deg);
        box-shadow: 0 1px 1px #ccc;

        &--icon {
          position: absolute;
          color: white;
          cursor: pointer;
          top: 2px;
          right: 2px;
        }
      }
    }
  }
  &__title{
    font-size: 16px;
    color: #0E0525;
    line-height: 23px;
    min-height: 45px;
    display: flex;
    align-items: center;
  }
  &__content {
    border-left-width: 4px;
    border-left-style: solid ;
    border-left-color: red;
    padding-left: 20px;
  }

  .position {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .el-tag {
    margin-right: 10px;
    display: inline-block;
  }

  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    vertical-align: bottom;
  }
  /*.uploader {
    label {
      border: 1px dashed #d9d9d9;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &:hover {
        border-color: #e55279;

        i {
          color: #e55279;
        }
      }
    }
  }*/
  .list-item {

    &__image {
      width: 50px;
      height: 50px;
      float: left;
      position: relative;
      z-index: 1;
      margin-left: -80px;
      background-color: #fff;
      border-radius: 6px;
    }
    &__name {
      line-height: 50px;
    }
    &__delete {
      position: absolute;
      right: -17px;
      top: -7px;
      width: 46px;
      height: 26px;
      background: #c0ccda;
      text-align: center;
      transform: rotate(45deg);
      box-shadow: 0 1px 1px #ccc;

      &--icon {
        position: absolute;
        color: white;
        cursor: pointer;
        top: 2px;
        right: 2px;
      }
    }
    ul {
      margin: 0;
      padding: 0;
      li {
        position: relative;
        list-style: none;
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        margin-top: 10px;
        padding: 10px 10px 10px 90px;
        height: 72px;
      }
    }
  }
  &__assets {
    &--btn {
      height: 25px;
      width: 25px;
      padding: 0;
      margin-top: 10px;
    }
    &--content {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column;

      .asset-uploader {
        label {
          border: 1px dashed #d9d9d9;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          &:hover {
            border-color: #e55279;

            i {
              color: #e55279;
            }
          }
        }
      }
      .list-item {

        &__image {
          width: 50px;
          height: 50px;
          float: left;
          position: relative;
          z-index: 1;
          margin-left: -80px;
          background-color: #fff;
          border-radius: 6px;
        }
        &__name {
          line-height: 50px;
        }
        &__delete {
          position: absolute;
          right: -17px;
          top: -7px;
          width: 46px;
          height: 26px;
          background: #c0ccda;
          text-align: center;
          transform: rotate(45deg);
          box-shadow: 0 1px 1px #ccc;

          &--icon {
            position: absolute;
            color: white;
            cursor: pointer;
            top: 2px;
            right: 2px;
          }
        }
        ul {
          margin: 0;
          padding: 0;
          li {
            position: relative;
            list-style: none;
            overflow: hidden;
            background-color: #fff;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            margin-top: 10px;
            padding: 10px 10px 10px 90px;
            height: 72px;
          }
        }
      }
    }
  }
}
</style>
